import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SmartCaptcha } from '@yandex/smart-captcha';
import Modal from 'react-responsive-modal';
import { api } from 'src/api';
import { createGlobalStyle } from 'styled-components';
import { RE_CAPTCHA_SITE_KEY } from './constants';
import {
  pushFailedReCaptchaAnalytics,
  pushSuccessReCaptchaAnalytics,
} from './analytics';
import styles from './ReCaptchaModal.module.css';

interface ReCaptchaModalProps {
  reCaptchaSiteKey?: string;
  className?: string;
  isOpened: boolean;
  onCaptchaPassed?: () => void;
}

export const ReCaptchaModal = ({
  reCaptchaSiteKey = RE_CAPTCHA_SITE_KEY,
  className,
  isOpened,
  onCaptchaPassed,
}: ReCaptchaModalProps): JSX.Element | null => {
  const [isOpenLocal, setIsOpenLocal] = useState(isOpened);

  useEffect(() => {
    setIsOpenLocal(isOpened);
  }, [isOpened]);

  const handleChange = async (key: string) => {
    // отправляем запрос на бэк, чтобы проверефицировать результат прохождения капчи в сервисе google
    const response = await api.postClientRecaptcha({ token: key });

    // закрываем окно и отправляем пуш о удачном прохождении с капчей, если бэк сказал что все ок
    if (response.success) {
      setIsOpenLocal(false);
      pushSuccessReCaptchaAnalytics();
    }

    if (!response.success) {
      pushFailedReCaptchaAnalytics();
    }

    if (response.success && onCaptchaPassed) {
      onCaptchaPassed();
    }
  };

  if (!isOpenLocal) {
    return null;
  }

  return (
    <>
      <GlobalStyle />
      {/** TODO: @see https://tracker.yandex.ru/LT-39577 */}
      {/** @ts-ignore */}
      <Modal
        classNames={{
          overlay: styles.captcha,
          modal: className,
        }}
        showCloseIcon={false}
        center
        open
        onClose={() => {
          throw new Error('Function not implemented.');
        }}
      >
        <SmartCaptcha sitekey={reCaptchaSiteKey} onSuccess={handleChange} />
      </Modal>
    </>
  );
};

const GlobalStyle = createGlobalStyle`
  .captcha {
    z-index: 12000;
  }
`;
